import demographicInformationJSON from "./jsonsAdolescent/demographicInformationJSON";
import presentingProblemJSON from "./jsonsAdolescent/presentingProblemJSON";
import medicalHistoryJSON from "./jsonsAdolescent/medicalHistoryJSON";
import educationHistoryJSON from "./jsonsAdolescent/educationHistorJSON";
import alcoholHistoryJSON from "./jsonsAdolescent/alcoholHistoryJSON";
import legalHistoryJSON from "./jsonsAdolescent/legalHistoryJSON";
import familyHistoryJSON from "./jsonsAdolescent/familyHistoryJSON";
import behavioralHistoryJSON from "./jsonsAdolescent/behavioralHistoryJSON";
import summaryRecomendationsJSON from "./jsonsAdolescent/summaryRecomendationsJSON";
import asamCriteriaJSON from "./jsonsAdolescent/asamCriteriaJSON";
import mseJSON from "./jsonsAdolescent/mseJSON";
import collateralJSON from "./jsonsAdolescent/collateralJSON";
import strengthsJSON from "./jsonsAdolescent/strengthsJSON";
import suggestedRecomendation from "./jsonsAdolescent/suggestedRecomendation";
import progressNotesJSON from "./progressNotesPattern"

const adolescentPattern = [
  //========================================================================================
  /*                                                                                      *
   *                                Demographic Information                               *
   *                                                                                      */
  //========================================================================================
  demographicInformationJSON,
  //========================================================================================
  /*                                                                                      *
   *                         Presenting Problem/Primary Complaint                         *
   *                                                                                      */
  //========================================================================================

  presentingProblemJSON,
  //========================================================================================
  /*                                                                                      *
   *                                    Medical History                                   *
   *                                                                                      */
  //========================================================================================
  medicalHistoryJSON,
  //========================================================================================
  /*                                                                                      *
   *                      Education, Employment and Military History                      *
   *                                                                                      */
  //========================================================================================
  educationHistoryJSON,
  //========================================================================================
  /*                                                                                      *
   *                               Drug and Alcohol History                               *
   *                                                                                      */
  //========================================================================================

  alcoholHistoryJSON,
  //========================================================================================
  /*                                                                                      *
   *                                         Legal History                                       *
   *                                                                                      */
  //========================================================================================
  legalHistoryJSON,
  //========================================================================================
  /*                                                                                      *
   *                                    Family History                                    *
   *                                                                                      */
  //========================================================================================
  familyHistoryJSON,
  //========================================================================================
  /*                                                                                      *
   *                               Behavioral Health History                              *
   *                                                                                      */
  //========================================================================================
  behavioralHistoryJSON,
  //========================================================================================
  /*                                                                                      *
   *                           Diagnosis/Summary/Recommendations                          *
   *                                                                                      */
  //========================================================================================
  // summaryRecomendationsJSON,
  //========================================================================================
  /*                                                                                      *
   *                                       OPTIONAL                                       *
   *                                                                                      */
  //========================================================================================

  // {
  //   section: "OPTIONAL",
  //   topic: "OPTIONAL SECTIONS. CHECK TO INCLUDE",
  //   checked: "false",
  //   // access: "private",
  //   color: "info",
  //   body: [],
  // },
  //========================================================================================
  /*                                                                                      *
   *                                     ASAM Criteria                                    *
   *                                                                                      */
  //========================================================================================
  asamCriteriaJSON,
  //========================================================================================
  /*                                                                                      *
   *                            Mental Status Examination (MSE)                           *
   *                                                                                      */
  //========================================================================================

  mseJSON,
  //========================================================================================
  /*                                                                                      *
   *                                Collateral Information                                *
   *                                                                                      */
  //========================================================================================

  collateralJSON,
  //========================================================================================
  /*                                                                                      *
   *                               Strengths and Challenges                                *
   *                                                                                      */
  //========================================================================================
  strengthsJSON,
  //========================================================================================
  /*                                                                                      *
   *                           Diagnosis/Summary/Recommendations                          *
   *                                                                                      */
  //========================================================================================
  summaryRecomendationsJSON,
  //========================================================================================
  /*                                                                                      *
   *                           Diagnosis/Summary/Recommendations                          *
   *                                                                                      */
  //========================================================================================
  suggestedRecomendation,
//========================================================================================
/*                                                                                      *
 *                                   progressNotesJSON                                  *
 *                                                                                      */
//========================================================================================
  progressNotesJSON,
];

export default adolescentPattern;
